import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

const initialState = {
  items: JSON.parse(localStorage.getItem('wishlistItems')) || [], // Load wishlist items from local storage or initialize as empty
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    //Reducer to add or remove item to/from wishlist
    toggleWishlistItem: (state, action) => {
      // Check if the ID already exists in addedProducts
      const itemExists = state.items.find(
        (item) => item.id === action.payload.id
      );

      if (itemExists) {
        // Remove item from wishlist
        state.items = state.items.filter(
          (item) => item.id !== action.payload.id
        );
        toast.info(`${action.payload.title} removed from Wishlist.`, {
          position: 'top-center',
        }); // Show info message
      } else {
        state.items.push(action.payload); // Add new item to wishlist
        toast.success(`${action.payload.title} added to Wishlist!`, {
          position: 'top-center',
        }); // Show success message
      }

      localStorage.setItem('wishlistItems', JSON.stringify(state.items)); // Save the update wishlist items to local storage
    },
  },
});

export const { toggleWishlistItem } = wishlistSlice.actions;
export default wishlistSlice.reducer;
